import { Col, Row, Tabs } from "antd";
import React from "react";
import PageHeader from "../../components/Elements/PageHeader";
import { ShoppingCartOutlined } from "@ant-design/icons";
import ActiveTapeOrders from "./ActiveTapeOrders";

export default function TapeOders() {
  const onChange = (key) => {
    console.log(key);
  };
  const items = [
    {
      key: "1",
      label: `Active Orders`,
      children: <ActiveTapeOrders />,
    },
  ];
  return (
    <div style={{ padding: 15 }}>
      <Row>
        <Col span={24}>
          <PageHeader text="Tape Orders" icon={<ShoppingCartOutlined />} />
        </Col>
        <Col span={24}>
          <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
        </Col>
      </Row>
    </div>
  );
}
